export interface KnowledgeDiscoveryTopicByIdVariables {
	cloudId: string;
	topicId: string;
	userCount: number;
}

export interface KnowledgeDiscoveryTopic {
	id: string;
	name: string;
	description: string;
	message?: string;
}

type AccountStatus = 'active' | 'inactive' | 'closed';

export interface User {
	id: string;
	name: string;
	picture: string;
	accountId: string;
	accountStatus: AccountStatus;
	extendedProfile?: {
		jobTitle?: string;
	};
}

export interface KnowledgeDiscoveryUser {
	user?: User;
}

export interface KnowledgeDiscoveryRelatedEntityConnection<T> {
	message?: string;
	nodes?: T[];
}

export interface KnowledgeDiscoveryTopicByIdResult {
	topic: KnowledgeDiscoveryTopic;
	users: KnowledgeDiscoveryRelatedEntityConnection<KnowledgeDiscoveryUser>;
}

export interface KnowledgeDiscoveryTopicByIdData {
	knowledgeDiscovery: KnowledgeDiscoveryTopicByIdResult;
}

export const TOPIC_BY_ID_OPERATION_NAME = 'KnowledgeDiscoveryPlatformTopicByIdQuery';
export const TopicByIdQuery: '\n\tquery KnowledgeDiscoveryPlatformTopicByIdQuery($cloudId: String!, $topicId: String!, $userCount: Int!) {\n\t\tknowledgeDiscovery {\n\t\t\ttopic(cloudId: $cloudId, id: $topicId) {\n\t\t\t\t...on KnowledgeDiscoveryTopic {\n\t\t\t\t\tid\n\t\t\t\t\tname\n\t\t\t\t\tdescription\n\t\t\t\t}\n\t\t\t\t...on QueryError {\n\t\t\t\t\tmessage\n\t\t\t\t}\n\t\t\t}\n\t\t\tusers: relatedEntities(\n\t\t\t\tcloudId: $cloudId\n\t\t\t\tentityId: $topicId\n\t\t\t\tentityType: TOPIC\n\t\t\t\trelatedEntityType: USER\n\t\t\t\tfirst: $userCount\n\t\t\t) @optIn(to: "KnowledgeDiscovery Get Related Entities") {\n\t\t\t\t...on KnowledgeDiscoveryRelatedEntityConnection {\n\t\t\t\t\tnodes {\n\t\t\t\t\t\t...on KnowledgeDiscoveryUser {\n\t\t\t\t\t\t\tuser {\n\t\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\t\tname\n\t\t\t\t\t\t\t\tpicture\n\t\t\t\t\t\t\t\taccountId\n\t\t\t\t\t\t\t\taccountStatus\n\t\t\t\t\t\t\t\t...on AtlassianAccountUser {\n\t\t\t\t\t\t\t\t\textendedProfile {\n\t\t\t\t\t\t\t\t\t\tjobTitle\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t...on QueryError {\n\t\t\t\t\tmessage\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n' = `
	query ${TOPIC_BY_ID_OPERATION_NAME}($cloudId: String!, $topicId: String!, $userCount: Int!) {
		knowledgeDiscovery {
			topic(cloudId: $cloudId, id: $topicId) {
				...on KnowledgeDiscoveryTopic {
					id
					name
					description
				}
				...on QueryError {
					message
				}
			}
			users: relatedEntities(
				cloudId: $cloudId
				entityId: $topicId
				entityType: TOPIC
				relatedEntityType: USER
				first: $userCount
			) @optIn(to: "KnowledgeDiscovery Get Related Entities") {
				...on KnowledgeDiscoveryRelatedEntityConnection {
					nodes {
						...on KnowledgeDiscoveryUser {
							user {
								id
								name
								picture
								accountId
								accountStatus
								...on AtlassianAccountUser {
									extendedProfile {
										jobTitle
									}
								}
							}
						}
					}
				}
				...on QueryError {
					message
				}
			}
		}
	}
`;
